import { createGlobalStyle } from "styled-components";
export const NormalizeStyles = createGlobalStyle `
  /*
DOCUMENT
========
*/

  /**
1. Use a better box model (opinionated).
2. Reset the margin on all elements.
*/

  *,
  ::before,
  ::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  /**
1. Correct the line height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size (opinionated).
4. 1rem = 16px, setting root to 62.5% makes 1rem = 10px and 1.6rem = 16px, which is easier to work with.
5. update the scroll behavior to smooth(opinionated).
*/

  html {
    line-height: 1.15; /* 1 */
    text-size-adjust: 100%; /* 2 */ /* 3 */
    tab-size: 4; /* 3 */
    font-size: 62.5%; /* 4 */
    scroll-behavior: smooth; /* 5 */
  }

  /*
SECTIONS
========
*/

  /**
1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
2. update body size (opinionated)
3. text rendering (opinionated)
4. logographic typography support (improves legibility of logographic characters)
*/

  body {
    font-family: system-ui, -apple-system, /* Firefox supports this but not yet system-ui */ "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"; /* 1 */

    min-height: 100vh; /* 2 */
    text-rendering: optimizespeed; /* 3 */
    &:lang(ko-kr),
    &:lang(ja-jp) { /* 4 */
      text-rendering: geometricprecision;
    }
  }

  /*
ELEMENTS
========
*/

  /* Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. */
  img,
  video {
    border: none;
    max-width: 100%;
    height: auto;
  }

  /**
 * Make replaced elements 'display: block' by default as that's
 * the behavior you want almost all of the time. Inspired by
 * CSS Remedy, with 'svg' added as well.
 *
 * https://github.com/mozdevs/cssremedy/issues/14
 */
  img,
  picture,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: block;
  }

  table {
    border-collapse: collapse;
  }

  /* 
TEXT SEMANTICS
========
*/

  /**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

  abbr[title] {
    border-bottom: none;
    text-decoration: underline dotted;
  }

  /* Add the correct font weight in Chrome, Edge, and Safari. */
  b,
  strong {
    font-weight: 700;
  }

  /**
 * Remove the gray background on active links in IE 10.
 */

  a {
    background-color: transparent;
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  /**
 * Add the correct font size in all browsers.
 */

  small {
    font-size: 80%;
  }

  /**
 * Prevent sub and sup elements from affecting the line height in all browsers.
 */

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /* Remove list styles on ul, ol elements to be replaced in global styles */
  ul,
  ol {
    list-style: none;
  }

  /**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd em font sizing in all browsers.
 */
  code,
  kbd,
  samp,
  pre {
    font-family: monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /* 
FORMS
========
*/

  button,
  input,
  optgroup,
  select,
  textarea {
    line-height: inherit;
    font: inherit;
  }

  /**
* Show the overflow in IE.
* 1. Show the overflow in Edge.
*/

  button,
  input {
    /* 1 */
    overflow: visible;
  }

  /**
* Remove the inheritance of text transform in Edge, Firefox, and IE.
* 1. Remove the inheritance of text transform in Firefox.
*/

  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
* Correct the inability to style clickable types in iOS and Safari.
*/

  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    appearance: button;
    background-color: transparent;
    border: none;
    background-image: none;
    cursor: pointer;
  }


  /**
* Correct the text wrapping in Edge and IE.
*/

  legend {
    display: table;
    max-width: 100%;
    white-space: normal;
  }

  /**
* Add the correct vertical alignment in Chrome, Firefox, and Opera.
*/

  progress {
    vertical-align: baseline;
  }

  /**
* Remove the default vertical scrollbar in IE 10+.
*/

  textarea {
    overflow: auto;
    resize: vertical;
  }

  /**
* Correct the cursor style of increment and decrement buttons in Chrome.
*/

  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  /**
* 1. Correct the odd appearance in Chrome and Safari.
* 2. Correct the outline style in Safari.
*/

  [type="search"] {
    appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  /**
* Remove the inner padding in Chrome and Safari on macOS.
*/

  [type="search"]::-webkit-search-decoration {
    appearance: none;
  }

  /**
* 1. Correct the inability to style clickable types in iOS and Safari.
* 2. Change font properties to inherit in Safari.
*/

  ::-webkit-file-upload-button {
    appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  /* 
INTERACTIVE
========
*/

  /*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */

  details {
    display: block;
  }

  /*
 * Add the correct display in all browsers.
 */

  summary {
    display: list-item;
  }

  /* 
IE Fixes
========
*/

  /**
 * Render element consistently in IE.
 */
  details,
  main {
    display: block;
  }



  /**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */

  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  /**
 * Add the correct display in IE 10+.
 */

  template {
    display: none;
  }

  /**
 * Add the correct display in IE 10.
 */
  template,
  [hidden] {
    display: none;
  }
`;
//# sourceMappingURL=normalize.js.map